<p-table
  #dt1
  [value]="data?.workers"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]=""
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="false"
>
  <ng-template pTemplate="caption">
    <div [formGroup]="form" class="page-control flex align-items-start">
      <div class="grid w-100">
        <div
          class="col-12 flex justify-content-between mb-2 align-items-center"
        >
          <h2 class="text-black-alpha-90">Periodični izveštaj</h2>

          <div class="flex">
            <button
              class="main-btn"
              [disabled]="!form.valid || data.length == 0"
              (click)="onExportCsv()"
              [ngClass]="{ disabled: !form.valid || data.length == 0 }"
            >
              Export CSV <i class="pi pi-file-excel"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum od"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_from"
            ></p-calendar>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_from')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum do"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_to"
            ></p-calendar>

            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_to')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="flex mb-0">
            <input
              class="w-full"
              pInputText
              type="text"
              (input)="onSearch()"
              placeholder="Koeficijent"
              formControlName="coef"
            />
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('coef')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-worker>
    <tr>
      <th>
        <span>Ime i prezime </span>
      </th>
      <th class="w-7rem">
        <span>Period</span>
      </th>

      <th>
        <span>Radnih dana</span>
      </th>
      <th>
        <span>Radnih sati</span>
      </th>

      <th class="work">
        <span>Rad</span>
      </th>
      <th class="pause">
        <span>Pauza</span>
      </th>
      <th class="off">
        <span>Odjavljen</span>
      </th>
      <th class="work">
        <span>Rad</span>
      </th>
      <th class="pause">
        <span>Pauza </span>
      </th>
      <th class="off">
        <span>Odjavljen </span>
      </th>
      <th>
        <span>Zarada</span>
      </th>
      <th class="w-5rem">
        <span>Koef.</span>
      </th>
      <th class="w-3rem">
        <span>Op.</span>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-worker>
    <tr>
      <td>
        <span>{{ worker?.fullname }}</span>
      </td>
      <td>
        <span>{{ worker?.period }}</span>
      </td>
      <td>
        <span>{{ worker?.workingDays }}</span>
      </td>
      <td>
        <span>{{ worker?.shiftHours }}</span>
      </td>

      <td class="work">
        <span>{{ worker?.workingHours }}</span>
      </td>
      <td class="pause">
        <span>{{ worker?.breakingHours }}</span>
      </td>
      <td class="off">
        <span>{{ worker?.logoutingHours }}</span>
      </td>
      <td class="work">
        <span>{{ worker?.workingHoursPercent }}% </span>
      </td>
      <td class="pause">
        <span>{{ worker?.breakingHoursPercent }}%</span>
      </td>
      <td class="off">
        <span>{{ worker?.logoutingHoursPercent }}%</span>
      </td>
      <td>
        <span>{{ worker?.earnings }} RSD</span>
      </td>
      <td>
        <span>{{ worker?.earnings_ratio }}%</span>
      </td>
      <td>
        <div class="flex justify-content-center">
          <a
            class="second-btn small-btn"
            pTooltip="Operacije"
            tooltipPosition="top"
            (click)="onShowOperations(worker?.operations)"
          >
            <i class="pi pi-pencil"></i>
          </a>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">Nema pronađenih prodataka.</td>
    </tr>
  </ng-template>
</p-table>

<div class="mt-4">
  <p-table
    #dt1
    [value]="totalScore"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [loading]=""
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
  >
    <ng-template pTemplate="header" let-score>
      <tr>
        <th>
          <span></span>
        </th>
        <th class="w-7rem">
          <span>Period</span>
        </th>

        <th>
          <span>Radnih dana</span>
        </th>
        <th>
          <span>Radnih sati</span>
        </th>

        <th class="work">
          <span>Rad</span>
        </th>
        <th class="pause">
          <span>Pauza</span>
        </th>
        <th class="off">
          <span>Odjavljen</span>
        </th>
        <th class="work">
          <span>Rad</span>
        </th>
        <th class="pause">
          <span>Pauza </span>
        </th>
        <th class="off">
          <span>Odjavljen </span>
        </th>
        <th>
          <span>Zarada</span>
        </th>

        <th class="w-3rem">
          <span>Op.</span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-score>
      <tr>
        <td>
          <span>{{ score?.headerAvg }}</span>
        </td>
        <td>
          <span>{{ score?.period }}</span>
        </td>
        <td>
          <span>{{ score?.workingDaysAvg }}</span>
        </td>
        <td>
          <span>{{ score?.shiftHoursAvg }}</span>
        </td>

        <td class="work">
          <span>{{ score?.workingHoursAvg }}</span>
        </td>
        <td class="pause">
          <span>{{ score?.breakingHoursAvg }}</span>
        </td>
        <td class="off">
          <span>{{ score?.logoutingHoursAvg }}</span>
        </td>
        <td class="work">
          <span>{{ score?.workingHoursPercentAvg }}% </span>
        </td>
        <td class="pause">
          <span>{{ score?.breakingHoursPercentAvg }}%</span>
        </td>
        <td class="off">
          <span>{{ score?.logoutingHoursPercentAvg }}%</span>
        </td>
        <td>
          <span>{{ score?.earnings_avg }} RSD</span>
        </td>

        <td>
          <div class="flex justify-content-center">
            <a
              class="second-btn small-btn"
              pTooltip="Operacije"
              tooltipPosition="top"
              (click)="onShowAvgOperations(score?.operations)"
            >
              <i class="pi pi-pencil"></i>
            </a>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="mt-4">
  <p-table
    #dt1
    [value]="totalScore"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [loading]=""
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
  >
    <ng-template pTemplate="header" let-score>
      <tr>
        <th>
          <span></span>
        </th>
        <th class="w-7rem">
          <span>Period</span>
        </th>

        <th>
          <span>Radnih dana</span>
        </th>
        <th>
          <span>Radnih sati</span>
        </th>

        <th class="work">
          <span>Rad</span>
        </th>
        <th class="pause">
          <span>Pauza</span>
        </th>
        <th class="off">
          <span>Odjavljen</span>
        </th>
        <th class="work">
          <span>Rad</span>
        </th>
        <th class="pause">
          <span>Pauza </span>
        </th>
        <th class="off">
          <span>Odjavljen </span>
        </th>
        <th>
          <span>Zarada</span>
        </th>

        <th class="w-3rem">
          <span>Op.</span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-score>
      <tr>
        <td>
          <span>{{ score?.header }}</span>
        </td>
        <td>
          <span>{{ score?.period }}</span>
        </td>
        <td>
          <span>{{ score?.workingDays }}</span>
        </td>
        <td>
          <span>{{ score?.shiftHours }}</span>
        </td>

        <td class="work">
          <span>{{ score?.workingHours }}</span>
        </td>
        <td class="pause">
          <span>{{ score?.breakingHours }}</span>
        </td>
        <td class="off">
          <span>{{ score?.logoutingHours }}</span>
        </td>
        <td class="work">
          <span>{{ score?.workingHoursPercent }}% </span>
        </td>
        <td class="pause">
          <span>{{ score?.breakingHoursPercent }}%</span>
        </td>
        <td class="off">
          <span>{{ score?.logoutingHoursPercent }}%</span>
        </td>
        <td>
          <span>{{ score?.earnings }} RSD</span>
        </td>

        <td>
          <div class="flex justify-content-center">
            <a
              class="second-btn small-btn"
              pTooltip="Operacije"
              tooltipPosition="top"
              (click)="onShowTotalOperations(score?.operations)"
            >
              <i class="pi pi-pencil"></i>
            </a>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- MODAL WITH OPERATIONS  ------------------------------>
<p-dialog
  header="Detalji operacija"
  [(visible)]="showOperations"
  [modal]="true"
  [style]="{ width: '80%', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (click)="onCloseModal(showOperations)"
>
  <p-table
    [value]="operationsData"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
  >
    <ng-template pTemplate="header" let-operation>
      <tr>
        <th>
          <span>Operacija </span>
        </th>
        <th>
          <span>Količina (kom) </span>
        </th>
        <th>
          <span>Koeficijent</span>
        </th>
        <th>
          <span>Vreme</span>
        </th>
        <th>
          <span>Vrednost</span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-operation>
      <tr>
        <td>
          <span>{{ operation?.name }}</span>
        </td>
        <td>
          <span>{{ operation?.total_amount }}</span>
        </td>
        <td>
          <span>{{ operation?.coefficient }}</span>
        </td>
        <td>
          <span>{{ operation?.total_time }}</span>
        </td>
        <td>
          <span>{{ operation?.total_price }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- MODAL WITH AVG OPERATIONS  ------------------------------>
<p-dialog
  header="Učinak operacija"
  [(visible)]="showAvgOperations"
  [modal]="true"
  [style]="{ width: '50vw', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (click)="onCloseModal(showAvgOperations)"
>
  <p-table
    [value]="totalOperationsData"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
  >
    <ng-template pTemplate="header" let-totalOperation>
      <tr>
        <th>
          <span>Operacija </span>
        </th>
        <th>
          <span>Učinak </span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-totalOperation>
      <tr>
        <td>
          <span>{{ totalOperation?.name }}</span>
        </td>
        <td>
          <span>{{ totalOperation?.total_amount_avg }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- MODAL WITH TOTAL OPERATIONS  ------------------------------>
<p-dialog
  header="Učinak operacija"
  [(visible)]="showTotalOperations"
  [modal]="true"
  [style]="{ width: '50vw', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (click)="onCloseModal(showTotalOperations)"
>
  <p-table
    [value]="totalOperationsData"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
  >
    <ng-template pTemplate="header" let-totalOperation>
      <tr>
        <th>
          <span>Operacija </span>
        </th>
        <th>
          <span>Učinak </span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-totalOperation>
      <tr>
        <td>
          <span>{{ totalOperation?.name }}</span>
        </td>
        <td>
          <span>{{ totalOperation?.total_amount }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
